import { GenericModelController } from "@/controllers/model-controllers/abstract/generic-model-controller.ts"
import { IncomingInvoice } from "@/models/incoming-invoice.model.ts"
import type { IIncomingInvoice } from "@/interfaces/api/incoming-invoice.interface.ts"
import { IncomingInvoiceRepository } from "@/repositories/incoming-invoice-repository.ts"
import { useIncomingInvoiceStore } from "@/store/incoming-invoices.store.ts"
import { storeToRefs } from "pinia"
import { useSocketSynchronizationHandlers } from "@/composables/socket/socket-synchronization-handlers.ts"
import type { IRepositoryRequestConfig } from "@/interfaces/repository/repository-request-config.interface.ts"

export class IncomingInvoiceController extends GenericModelController<
  IncomingInvoice,
  IIncomingInvoice,
  IncomingInvoiceRepository
> {
  constructor() {
    const incomingInvoiceStore = useIncomingInvoiceStore()
    const { incomingInvoices } = storeToRefs(incomingInvoiceStore)
    const storeFunctionsConfig = {
      collection: incomingInvoices
    }

    super(IncomingInvoice, storeFunctionsConfig, new IncomingInvoiceRepository())

    this.socketSynchronizationHandlers = useSocketSynchronizationHandlers(
      IncomingInvoice,
      incomingInvoices
    )
  }

  public async reExport(incomingInvoice: IncomingInvoice): Promise<IncomingInvoice> {
    const updatedInvoice = await this.apiFunctions.getRepository().reExport(incomingInvoice.id!)
    return this.storeFunctions.updateModel(updatedInvoice)
  }

  public async softDelete(
    incomingInvoice: IncomingInvoice,
    requestConfig?: IRepositoryRequestConfig
  ): Promise<IncomingInvoice | undefined> {
    return await this.update(
      incomingInvoice,
      {
        ...requestConfig,
        query: { delete: true }
      },
      true
    )
  }

  public async restore(
    incomingInvoice: IncomingInvoice,
    requestConfig?: IRepositoryRequestConfig
  ): Promise<IncomingInvoice | undefined> {
    return await this.update(
      incomingInvoice,
      {
        ...requestConfig,
        query: { restore: true }
      },
      true
    )
  }
}
